export default __webpack_public_path__ + "static/media/participacao.60b8833d.svg";